import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHero from '../components/PageHero';
import GetInvolved from '../components/GetInvolved';
import './Programs.css';

const PROGRAMS = [
  {
    image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'education',
    category: 'Education',
    icon: '🎓',
    iconBg: '#0F766E',
    color: 'var(--primary)',
    tag: 'Education',
    title: 'Education for All',
    desc: 'Quality education is the foundation of every life well-lived. Our Education for All programme provides scholarships, digital learning tools, and school infrastructure support to children in rural and tribal communities who would otherwise never get the chance to learn.',
    features: [
      'Annual merit-cum-need scholarships for Std 6–12 students',
      'Digital literacy labs in 20 rural government schools',
      'After-school tutoring centres in 30 villages',
      'School building renovation and sanitation facilities',
      'Free stationery, uniforms, and textbooks for 8,500+ students',
    ],
    stat1: { num: '8,500+', lbl: 'Students' },
    stat2: { num: '65', lbl: 'Schools' },
    progress: 78,
  },
  {
    image: 'https://images.unsplash.com/photo-1758691462482-2b6ccbaefa6e?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'healthcare',
    category: 'Healthcare',
    icon: '💊',
    iconBg: '#D97706',
    color: 'var(--secondary-dark)',
    tag: 'Healthcare',
    title: 'Community Healthcare',
    desc: 'Preventive care saves more lives than cure. Our mobile healthcare units bring doctors, medicines, and diagnostics directly to villages where the nearest hospital may be 50 km away. We run year-round camps focusing on maternal health, child nutrition, and chronic disease management.',
    features: [
      'Monthly free medical camps in 40+ villages',
      'Maternal and child health monitoring for 2,000 women',
      'Free eye check-up and cataract surgery programme',
      'Tuberculosis and malaria awareness & treatment support',
      'Mental health awareness workshops for rural youth',
    ],
    stat1: { num: '12,000+', lbl: 'Check-ups' },
    stat2: { num: '40', lbl: 'Camps/yr' },
    progress: 65,
  },
  {
    image: 'https://images.unsplash.com/photo-1708417134243-6d71770d82ef?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'women',
    category: 'Women',
    icon: '👩‍💼',
    iconBg: '#2563EB',
    color: 'var(--accent)',
    tag: 'Women',
    title: 'Women Empowerment',
    desc: 'When women thrive, families thrive, and communities thrive. We run skill-development programmes, form self-help groups, and provide micro-finance access to help women build economic independence — because empowered women are the engine of lasting social change.',
    features: [
      '90 active Self Help Groups across 3 districts',
      'Vocational training in tailoring, food processing & handicrafts',
      'Micro-finance linkage through NABARD partnerships',
      'Legal literacy and domestic rights workshops',
      'Leadership development for women in panchayat roles',
    ],
    stat1: { num: '3,200+', lbl: 'Women' },
    stat2: { num: '18', lbl: 'Districts' },
    progress: 55,
  },
  {
    image: 'https://images.unsplash.com/photo-1762884110133-926e4195d3b9?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'farming',
    category: 'Environment',
    icon: '🌾',
    iconBg: '#059669',
    color: '#059669',
    tag: 'Environment',
    title: 'Sustainable Farming',
    desc: 'Small and marginal farmers are the backbone of rural India — and the most vulnerable to climate change. We train farmers in organic practices, build rainwater harvesting systems, and connect them to markets that give fair prices for their produce.',
    features: [
      'Organic farming training for 1,800+ smallholder farmers',
      'Rainwater harvesting infrastructure in 12 villages',
      'Farmer Producer Organisations (FPOs) in 4 clusters',
      'Soil health testing and balanced fertilisation guidance',
      'Direct market linkages for fair produce pricing',
    ],
    stat1: { num: '1,800+', lbl: 'Farmers' },
    stat2: { num: '24', lbl: 'Villages' },
    progress: 70,
  },
  {
    image: 'https://images.unsplash.com/photo-1617878227827-8360231f7f03?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'children',
    category: 'Children',
    icon: '🧒',
    iconBg: '#E11D48',
    color: '#E11D48',
    tag: 'Children',
    title: 'Child Welfare',
    desc: 'Every child deserves a safe, nourished, and joyful childhood. Our child welfare programme runs nutrition intervention, child rights advocacy, and after-school safe spaces that protect children from exploitation and support their holistic development.',
    features: [
      'Daily nutrition supplementation for 5,000+ children',
      '30 Child Friendly Spaces (CFS) with trained caregivers',
      'Child rights and protection workshops in schools',
      'Psycho-social support for children from vulnerable homes',
      'Early childhood development programme (ages 3–6)',
    ],
    stat1: { num: '5,000+', lbl: 'Children' },
    stat2: { num: '30', lbl: 'Centres' },
    progress: 80,
  },
  {
    image: 'https://images.unsplash.com/photo-1549780100-a15a819b8ac5?auto=format&fit=crop&w=700&h=500&q=80',
    id: 'rural',
    category: 'Rural',
    icon: '🏘️',
    iconBg: '#7C3AED',
    color: '#7C3AED',
    tag: 'Rural',
    title: 'Rural Development',
    desc: 'Infrastructure is the foundation of opportunity. We work with village panchayats to build clean water systems, sanitation facilities, and all-weather roads — tackling the physical barriers that keep communities isolated and underserved.',
    features: [
      'Clean drinking water systems for 120 villages',
      'Household toilet construction under Swachh Bharat',
      'Community hall and library construction in 15 villages',
      'Street light installation using solar energy',
      'Road and pathway improvement for 8 tribal hamlets',
    ],
    stat1: { num: '120', lbl: 'Villages' },
    stat2: { num: '5', lbl: 'Districts' },
    progress: 42,
  },
];

const CATEGORIES = ['All', 'Education', 'Healthcare', 'Women', 'Environment', 'Children', 'Rural'];

const HOW_WE_WORK = [
  { num: '01', icon: '🔍', title: 'Community Assessment', desc: 'We conduct ground-level surveys to understand specific needs before designing any programme.' },
  { num: '02', icon: '🤝', title: 'Local Partnership', desc: 'Every programme is co-designed with village leaders, self-help groups, and panchayat representatives.' },
  { num: '03', icon: '⚙️', title: 'Implementation', desc: 'Trained field staff and volunteers execute programmes with full community participation.' },
  { num: '04', icon: '📊', title: 'Measure & Improve', desc: 'We track outcomes rigorously and publish annual impact reports for full donor transparency.' },
];

export default function Programs() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filtered = activeCategory === 'All'
    ? PROGRAMS
    : PROGRAMS.filter(p => p.category === activeCategory);

  return (
    <main id="main-content">
      <PageHero
        label="What We Do"
        title="Programs Changing Lives Every Day"
        desc="Six interconnected programmes addressing the root causes of poverty — from education and healthcare to women's empowerment and sustainable agriculture."
        breadcrumb="Programs"
        bgImage="https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=1600&h=600&q=80"
      />

      {/* Filter bar */}
      <div className="programs-filter-bar" role="navigation" aria-label="Filter programs by category">
        <div className="container">
          <div className="filter-tabs" role="list">
            {CATEGORIES.map(cat => (
              <button
                key={cat}
                className={`filter-tab${activeCategory === cat ? ' active' : ''}`}
                onClick={() => setActiveCategory(cat)}
                aria-pressed={activeCategory === cat}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Program detail cards */}
      <section className="programs-page-list section" aria-label="Program details">
        <div className="container">
          {filtered.map(p => (
            <article className="program-detail-card" key={p.id} id={p.id} aria-labelledby={`prog-title-${p.id}`}>
              <div className="program-detail-inner">
                <div className="program-detail-img">
                  <img src={p.image} alt={p.title} className="program-detail-photo" loading="lazy" />
                  <div className="program-detail-img-overlay" aria-hidden="true" style={{ background: `linear-gradient(to bottom, ${p.iconBg}22 0%, ${p.iconBg}66 100%)` }} />
                  <div className="program-detail-img-stats">
                    <div className="pdi-stat">
                      <div className="pdi-stat-num">{p.stat1.num}</div>
                      <div className="pdi-stat-lbl">{p.stat1.lbl}</div>
                    </div>
                    <div className="pdi-stat-divider" aria-hidden="true" />
                    <div className="pdi-stat">
                      <div className="pdi-stat-num">{p.stat2.num}</div>
                      <div className="pdi-stat-lbl">{p.stat2.lbl}</div>
                    </div>
                  </div>
                </div>

                <div className="program-detail-body">
                  <div className="program-detail-tag" style={{ color: p.color }}>
                    <span>{p.tag}</span>
                  </div>
                  <h2 className="program-detail-title" id={`prog-title-${p.id}`}>{p.title}</h2>
                  <p className="program-detail-desc">{p.desc}</p>

                  <ul className="program-detail-features" aria-label={`${p.title} features`}>
                    {p.features.map(f => (
                      <li className="program-detail-feature" key={f}>
                        <span className="feature-check" aria-hidden="true">✓</span>
                        {f}
                      </li>
                    ))}
                  </ul>

                  <div className="program-detail-footer">
                    <div className="program-progress-section">
                      <div className="prog-progress-label">
                        <span>Annual target progress</span>
                        <strong>{p.progress}%</strong>
                      </div>
                      <div
                        className="prog-bar-bg"
                        role="progressbar"
                        aria-valuenow={p.progress}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        aria-label={`${p.title} progress: ${p.progress}%`}
                      >
                        <div className="prog-bar" style={{ width: `${p.progress}%`, background: `linear-gradient(90deg, ${p.iconBg} 0%, ${p.iconBg}cc 100%)` }} />
                      </div>
                    </div>
                    <Link to="/contact" className="btn btn-primary btn-sm">Learn More</Link>
                  </div>
                </div>
              </div>
            </article>
          ))}

          {filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '4rem 0', color: 'var(--gray-400)' }}>
              No programmes found for this category.
            </div>
          )}
        </div>
      </section>

      {/* How We Work */}
      <section className="how-we-work section" aria-labelledby="hww-heading">
        <div className="container">
          <div className="section-header">
            <span className="section-label">Our Methodology</span>
            <h2 className="section-title" id="hww-heading">How We Work</h2>
            <p className="section-subtitle">
              Every programme follows a community-first process — we listen before we act, partner before we build, and measure before we claim success.
            </p>
          </div>
          <div className="hww-steps" role="list">
            {HOW_WE_WORK.map(s => (
              <div className="hww-step" key={s.num} role="listitem">
                <div className="hww-step-num" aria-hidden="true">
                  <span className="hww-step-icon">{s.icon}</span>
                </div>
                <h3 className="hww-step-title">{s.title}</h3>
                <p className="hww-step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <GetInvolved />
    </main>
  );
}
